module.exports = __webpack_public_path__ + "static/media/aristoteles_desc5.6f7c7c40.png";